<template>
  <div v-html="webinarInfo.intro"></div>
</template>

<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Introduction",
  data() {
    return {
      webinarInfo: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
    }
  }
};
</script>

<style scoped></style>
